import dynamic from 'next/dynamic';
import { RoomStayDetailsModalProps } from './RoomStayDetailsModal.types';

export const RoomStayDetailsModal = dynamic<RoomStayDetailsModalProps>(() =>
  import('./RoomStayDetailsModal').then(module => module.RoomStayDetailsModal)
);
